<div class="w-full bg-cashea text-center py-1">
  <img
    width="100"
    src="../../../assets/icons/cashea-logo.svg"
    class="inline align-middle"
  />
  <span class="font-sans text-black font-semibold text-sm">Compra en cuotas lo que necesitas hoy.</span>
</div>
